import { useContent } from "@/hooks/useContent";
import { useSourceSearchLink } from "@/hooks/useSourceSearchLink";
import LegislationTable from "./components/LegislationTable";
import PageContent from "../PageContent";

const LegislationListView = () => {
  const { t } = useContent();
  const { isApplyingLink, tableKey } = useSourceSearchLink();

  return (
    <PageContent title={t("legislation.listView.heading")}>
      <div className="h-[calc(100vh-3rem)] p-4">
        {/* Kept unmounted while a stored source search is applied to the table
            state, so the table seeds itself from the restored search. */}
        {!isApplyingLink && <LegislationTable key={tableKey} />}
      </div>
    </PageContent>
  );
};

export default LegislationListView;
